var React = require('react');
var ReactNative = require('react-native');

import Icon from './wrappers/ReUpIcon';

var Globals = require('./Globals');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ArcMeter = require('./ArcMeter.js')
var ReUpIconButton = require('./ReUpIconButton.js');
var ShadowView = require('./ShadowView.js');
var ReUpText = require('./ReUpText');
var ReUpButton = require('./ReUpButton');
var NetworkManager = require('./NetworkManager');

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  DeviceEventEmitter,
  StyleSheet,
} = ReactNative;

var MK = require('./wrappers/react-native-material-kit-wrapper');

var {
  MKButton,
} = MK;

function getCreditPointsText(transaction, appManager)
{
  var locManager = appManager.getLocalizationManager();
  var creditTransaction = transaction.creditTransaction;
  var pointsTransaction = transaction.pointsTransaction;
  var passTransaction = transaction.passTransaction;
  var creditText = null;
  var pointsText = null;
  var passText = null;
  var dateText = null;
  var timeStamp = null;
  var userName = "";
  var transactionIDs = [];

  if( creditTransaction ) transactionIDs.push(creditTransaction.TransactionID);
  if( pointsTransaction ) transactionIDs.push(pointsTransaction.TransactionID);
  if( passTransaction ) transactionIDs.push(passTransaction.TransactionID);

  if( creditTransaction != null )
  {
    if( typeof creditTransaction.UserName !== 'undefined' && creditTransaction.UserName.length > 0 ) userName = creditTransaction.UserName;
    dateText = typeof creditTransaction.TimestampEpoch !== 'undefined' && creditTransaction.TimestampEpoch > 0 ? appManager.timeSince(creditTransaction.TimestampEpoch) : appManager.timeSince(creditTransaction.Timestamp)
    timeStamp = creditTransaction.Timestamp;
    var credit = parseFloat(creditTransaction['Credit']);
    if( credit == 0 )
    {

    }
    else if( credit < 0 )
    {
      if( creditTransaction["Source"] == "99" )
      {
        creditText = locManager.localizedStringForKeyAndParams("USER_REFUNDED_STATEMENT", [locManager.localizedDollars(-credit)]);
      }
      else if( creditTransaction["Source"] == "6" )
      {
        creditText = locManager.localizedStringForKeyAndParams("USER_SENT_GC_STATEMENT", [locManager.localizedDollars(-credit), "You sent a %0% gift card!"])
      }
      else
      {
        creditText = locManager.localizedStringForKeyAndParams("USER_WITHDREW_STATEMENT", [locManager.localizedDollars(-credit)]);
      }
    }
    else
    {
      if( creditTransaction["Source"] == "99" )
      {
        creditText = locManager.localizedStringForKeyAndParams("USER_REFUNDED_STATEMENT", [locManager.localizedDollars(credit)]);
      }
      else if( creditTransaction["Source"] == "6" )
      {
        creditText = locManager.localizedStringForKeyAndParams("USER_RECEIVED_GC_STATEMENT", [locManager.localizedDollars(credit)], "You received a %0% gift card!");
      }
      else if( creditTransaction["Source"] == "11" )
      {
         creditText = locManager.localizedStringForKeyAndParams("USER_TRANSFERRED_OLD_ACCOUNT_STATEMENT", [locManager.localizedDollars(credit)], "You transferred %0% from an old loyalty account!");
      }
      else
      {
        creditText = locManager.localizedStringForKeyAndParams("USER_DEPOSITED_STATEMENT", [locManager.localizedDollars(credit)]);
      }
    }
  }

  if( pointsTransaction != null )
  {
    if( typeof pointsTransaction.UserName !== 'undefined' && pointsTransaction.UserName.length > 0 ) userName = pointsTransaction.UserName;
    dateText = typeof pointsTransaction.TimestampEpoch !== 'undefined' && pointsTransaction.TimestampEpoch > 0 ? appManager.timeSince(pointsTransaction.TimestampEpoch) : appManager.timeSince(pointsTransaction.Timestamp)
    timeStamp = pointsTransaction.Timestamp;
    var points = parseInt(pointsTransaction['Points'])
    if( points == 0 )
    {

    }
    else if( points < 0 )
    {
      points = Math.abs(points)
      if( pointsTransaction["Source"] == "99" )
      {
        pointsText = locManager.localizedStringForKeyAndParams("USER_LOST_STATEMENT", [locManager.localizedPoints(points)]);
      }
      else if( pointsTransaction["Source"] == "6" )
      {
        pointsText = "You sent " + [locManager.localizedPoints(points)] + "!";
      }
      else
      {
        pointsText = locManager.localizedStringForKeyAndParams("USER_REDEEMED_STATEMENT", [locManager.localizedPoints(points)]);
      }
    }
    else
    {
      var locPoints = locManager.localizedPoints(points);
      if( pointsTransaction["Source"] == "99" )
      {
        pointsText = locManager.localizedStringForKeyAndParams("USER_REFUNDED_STATEMENT", [locPoints]);
      }
      else if( pointsTransaction["Source"] == "6" )
      {
        pointsText = locManager.localizedStringForKeyAndParams("USER_RECEIVED_POINTS_STATEMENT", [locPoints], "You received %0%!");
      }
      else if( pointsTransaction["Source"] == "11" )
      {
        pointsText = locManager.localizedStringForKeyAndParams("USER_TRANSFERRED_OLD_ACCOUNT_STATEMENT", [locPoints], "You transferred %0% from an old loyalty account!");
      }
      else if( pointsTransaction["Source"] == "10" )
      {
        pointsText = locManager.localizedStringForKeyAndParams("USER_EARNED_POINTS_FOR_REFERRAL", [locPoints], "You earned %0% for a referral!");
      }
      else
      {
        pointsText = locManager.localizedStringForKeyAndParams("USER_EARNED_STATEMENT", [locPoints], "You earned %0%!");
      }
    }
  }

  if( passTransaction != null )
  {
    if( typeof passTransaction.UserName !== 'undefined' && passTransaction.UserName.length > 0 ) userName = passTransaction.UserName;
    dateText = typeof passTransaction.TimestampEpoch !== 'undefined' && passTransaction.TimestampEpoch > 0 ? appManager.timeSince(passTransaction.TimestampEpoch) : appManager.timeSince(passTransaction.Timestamp)
    timeStamp = passTransaction.Timestamp;
    if( passTransaction.IsCredit == "1" )
    {
      passText = locManager.localizedStringForKeyAndParams("PASS_TRANSACTION_PURCHASE", [passTransaction.PassQuantityRemaining, passTransaction.PassName, locManager.localizedDollars(passTransaction.Credit)], "You purchased %0% %1% for %2%!");
    }
    else
    {
      passText =  locManager.localizedStringForKeyAndParams("PASS_TRANSACTION_REDEEMED", [passTransaction.PassName], "You redeemed one of the %0%.");
      if( passTransaction.PassQuantityRemaining > 0 ) passText += " " + locManager.localizedStringForKeyAndParams("PASS_TRANSACTION_REDEEMED", [passTransaction.PassQuantityRemaining], "Only %0% are left!");
      else passText += " " + locManager.localizedStringForKey("PASS_TRANSACTION_NONE_ARE_LEFT", "None are left.");
    }
  }

  if( userName.length > 0 && !appManager.isValidEmail(userName) ) userName = appManager.getLocalizationManager().localizedPhone(userName);

  return {creditText: creditText, pointsText: pointsText, passText: passText, dateText: dateText, timeStamp: timeStamp, transactionIDs, userName};
}

function compiledTransactions(transactions, appManager)
{
  var timeThreshold = 2000;
  if( transactions == null ) return [];

  transactions = transactions.sort(function(a,b)
  {
    return appManager.getTime(b.Timestamp) - appManager.getTime(a.Timestamp);
  });
  var compiledTransactions = [];
  for( var i = 0; i < transactions.length; i++ )
  {
    var thisTrans = transactions[i];
    if( thisTrans.IsDeleted == '1' ) continue;
    var thisCreditTrans = null;
    var thisPointsTrans = null;
    var thisPassTrans = null;
    if( thisTrans.IsCredit == "1" )
    {
      if( typeof thisTrans.PassID !== 'undefined' && thisTrans.PassID.length > 0 && thisTrans.PassID >= 0 )
      {
        thisPassTrans = thisTrans;
      }
      else
      {
        thisCreditTrans = thisTrans;
      }
    }
    else
    {
      if( typeof thisTrans.PassID !== 'undefined' && thisTrans.PassID.length > 0 && thisTrans.PassID >= 0 )
      {
        thisPassTrans = thisTrans;
      }
      else
      {
        thisPointsTrans = thisTrans;
      }
    }

    if( i < (transactions.length-1) )
    {
      var nextTrans = transactions[i+1];
      if( nextTrans.IsDeleted == '1' ) continue;
      var thisTime = appManager.getTime(thisTrans.Timestamp);
      var nextTime = appManager.getTime(nextTrans.Timestamp);
      if( Math.abs(thisTime - nextTime) <= timeThreshold )
      {
        if( typeof nextTrans.PassID !== 'undefined' && nextTrans.PassID.length > 0 && thisPassTrans != null )
        {
          if( thisPassTrans.Credit < 0 && nextTrans.Credit > 0 )
          {
            thisPassTrans = nextTrans;
          }
          i++;
        }
        else if( nextTrans.IsCredit == "1" && thisCreditTrans == null )
        {
          thisCreditTrans = nextTrans;
          i++
        }
        else if( thisPointsTrans == null && nextTrans.IsCredit != "1" )
        {
          thisPointsTrans = nextTrans;
          i++
        }
      }
    }
    compiledTransactions.push({pointsTransaction:thisPointsTrans, creditTransaction:thisCreditTrans, passTransaction:thisPassTrans});
  }

  return compiledTransactions;
}


var Refunds = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      refunds : [],
    }
  },

  componentDidMount : function()
  {
    // this.didUpdate();
  },

  didUpdate : function(data)
  {
    if( typeof data.EligibleRefunds !== 'undefined' )
    {
      var transactions  = data.EligibleRefunds;
      transactions = compiledTransactions(transactions, this.props.appManager);

      this.setState({refunds:transactions});
    }
    // if( this.props.appManager.currentUser()[ModelConstants.UserName].toLowerCase() == "kjregan10@gmail.com" )
    // {
    //   refunds.setState({refunds:[
    //         {
    //             "RefundID": "-1",
    //             "RefundName": "Free Item",
    //             "Description": "Enjoy one of our signature Items, on the house!",
    //             "Points": "100",
    //             "IsDeleted": "0"
    //         },
    //         {
    //             "RefundID": "-2",
    //             "RefundName": "Free Thing",
    //             "Description": "Feeling thirsty today? We've got the Thing you need!",
    //             "Points": "200",
    //             "IsDeleted": "0"
    //         },
    //         {
    //             "RefundID": "-3",
    //             "RefundName": "Free Stuff",
    //             "Description": "Keep it up! You've got the Stuff!",
    //             "Points": "500",
    //             "IsDeleted": "0"
    //         }
    //     ]});
    //     return;
    // }
  },

  didSelectRefund : function(refund)
  {
    var credit = 0;
    var points = 0;
    if( typeof refund.creditTransaction !== 'undefined' && refund.creditTransaction != null )
    {
      refund = refund.creditTransaction;
      credit = -refund.Credit;
    }
    if( typeof refund.pointsTransaction !== 'undefined' && refund.pointsTransaction != null  )
    {
      refund = refund.pointsTransaction;
      points = -refund.Points;
    }
    if( typeof refund.passTransaction !== 'undefined' && refund.passTransaction != null  ) refund = refund.passTransaction;

    var thisThing = this;
    var appActions = this.props.appActions;
    var locMan = this.props.appManager.getLocalizationManager();
    var refundAlertTitle = locMan.localizedStringForKeyAndParams("REFUND_CREDIT_AND_POINTS_ALERT_BODY", [locMan.localizedDollars(credit), locMan.localizedPoints(points)], "Refund %0%, %1% and other related transactions?");
    appActions.showLocalizedAlert("REFUND_CREDIT_AND_POINTS_ALERT_TITLE", refundAlertTitle, ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [appActions.hideAlert(),()=>
    {
      appActions.hideAlert()
      appActions.setSpinnerShown(true, thisThing.locMan.localizedStringForKey("REFUNDING_SPINNER", "Refunding..."))
      NetworkManager.refund(thisThing.props.appManager, refund.TransactionID, ()=>
      {
        thisThing.refs.ptr.doOnlineUpdate();
        setTimeout(()=>
        {
          appActions.setSpinnerShown(false);
        }, 1000)
      }, ()=>
      {
        appActions.setSpinnerShown(false);
      })
    }])
  },

  render: function()
  {
    var thisRefunds = this;
    var appManager = this.props.appManager;
    var locManager = this.props.appManager.getLocalizationManager();
    var user = appManager.currentUser();

    var instructionColor = appManager.getColorForKey("InstructionColor");
    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var buttonPrimaryColor = appManager.getColorForKey("ButtonPrimaryColor");
    var profileMeterBackgroundColor = appManager.getColorForKey("SecondaryColor");
    if( profileMeterBackgroundColor == generalColor ) profileMeterBackgroundColor = appManager.getColorForKey("PrimaryColor",0.4);
    var profileMeterColor = appManager.getColorForKey("PrimaryColor");
    var offRowBackgroundColor = appManager.getColorForKey("GeneralTitleColor",0.05);

    var pointsLeftStatement = locManager.localizedStringForKey("POINTS_LEFT_STATEMENT");

    var refunds = this.state.refunds.sort(function(a,b)
    {
      return b.TransactionID - a.TransactionID;
    });

    var numUserPoints = user[ModelConstants.Points];
    return (
      <View style={styles.container}>
        <View style={[styles.backgroundView, {width:this.state.layout.width, height:this.state.layout.height, backgroundColor: generalColor}]} />
        <ReUpScrollView ref="ptr" bounces={true} responder={this} featureName="Refunds" isEmpty={refunds.length <= 0}>
          <ShadowView appManager={appManager} layout={this.state.layout} />
          <View style={{height:Globals.STATUS_BAR_HEIGHT}} />
          {
            refunds.map(function(refund, index)
            {
              var text = getCreditPointsText(refund, appManager);

              return (
                <MKButton key={refund.TransactionID} style={[styles.refundRowContainer]}
                  backgroundColor={'transparent'}
                  shadowRadius={2}
                  shadowOffset={{width:0, height:2}}
                  shadowOpacity={0.7}
                  shadowColor={'transparent'}
                  onPress={() => {
                    thisRefunds.didSelectRefund(refund);
                  }}
                  >
                  <View style={[styles.refundRow,{backgroundColor:index%2==0?offRowBackgroundColor:'transparent'}]}>
                    <View style={styles.refundLeftContainer}>
                      <ReUpText appManager={appManager} style={[{opacity:.6, color:generalTitleColor}]}>{locManager.dateTime(text.timeStamp)}</ReUpText>
                      { text.userName.length > 0 ? <ReUpText appManager={appManager} style={[{opacity:.6, color:generalTitleColor}]}>{text.userName}</ReUpText> : null }
                      {
                        text.creditText == null ? null : <ReUpText appManager={appManager} style={[{color:generalTitleColor}]}>{text.creditText}</ReUpText>
                      }
                      {
                        text.pointsText == null ? null : <ReUpText appManager={appManager} style={[{color:generalTitleColor}]}>{text.pointsText}</ReUpText>
                      }
                      {
                        text.passText == null ? null : <ReUpText appManager={appManager} style={[{color:generalTitleColor}]}>{text.passText}</ReUpText>
                      }
                    </View>
                    <View style={styles.refundRightContainer}>
                      <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor, fontSize:12, textAlign:'center'}]}>
                        {locManager.localizedStringForKeyAndParams("TRANS_ID_LABEL_AND_ID", [text.transactionIDs.join()])}
                      </ReUpText>
                    </View>
                  </View>
                  <View style={styles.refundDivider} />
                </MKButton>
              )
            })
          }
        </ReUpScrollView>
        <View style={{alignSelf:'stretch', backgroundColor:generalColor}}>
          <ReUpButton isSecondary={true} style={[styles.button,{margin:10, paddingLeft:20, paddingRight:20}]}
            appManager={appManager}
            text={locManager.localizedStringForKey("CANCEL_BUTTON")}
            onPress={() =>
            {
              thisRefunds.props.appActions.requestPop(false)
            }}
            />
        </View>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  instructionContainer: {
    backgroundColor:'blue',
    flexDirection:'row',
  },
  instructionText: {
    margin:10,
  },
  backgroundView: {
    position: 'absolute',
  },
  refundRowContainer: {

  },
  refundRow: {
    flexDirection:'row',
    alignItems:'center',
  },
  refundDivider: {
    height:1,
    backgroundColor:'#DADADA'
  },
  refundLeftContainer: {
    paddingTop:8,
    marginLeft:4,
    marginRight:4,
    paddingBottom:8,
    flex:1,
    justifyContent:'center',
    alignItems:'flex-start',
  },
  refundAmountContainer: {
    width:80,
    height:80,
    borderRadius:40,
    borderWidth:8,
    margin:10,
    justifyContent:'center',
    alignItems:'center',
    alignSelf:'center',
    flex:1,
  },
  refundAmount: {
    fontSize:34,
    flex:1,
    alignSelf:'center',
    justifyContent:'center',
  },
  refundRightContainer: {
    width:100,
    justifyContent:'center',
    paddingRight:8,
    paddingBottom:4,
    paddingTop:4
  },
  refundDescription: {
    padding:0,
    margin:0,
    opacity:.8,
  }

});

Refunds.getCards = function(featureData, appActions, data)
{
  var appManager = appActions._appManager;
  var isLoggedIn = appManager.isLoggedIn();

  if( !isLoggedIn ) return [];
  else
  {
    var user = appManager.currentUser();
    var points = parseFloat(user[ModelConstants.Points]);
    var refunds = typeof data.Refunds !== 'undefined' ? data.Refunds : [];
    var refunds = typeof data.Refunds !== 'undefined' ? data.Refunds.sort(function(a,b)
    {
      return a.Points - b.Points;
    }) : [];
    if( typeof refunds === 'undefined' || refunds == null || refunds.length <= 0 ) return [];

    var affordedRefund = null;
    for( var i = 0; i < refunds.length; i++ )
    {
      var refund = refunds[i];
      if( refund.Points <= points )
      {
        affordedRefund = refund;
      }
      else
      {
        break;
      }
    }
    if( affordedRefund == null ) return [];

    // get date acheived
    var sortOrder = -1;
    if( typeof data.Transactions !== 'undefined' )
    {
      var trans = data.Transactions;
      var runningPoints = points;
      var refundTrans = null;
      for( var i = 0; i < trans.length; i++ )
      {
        var thisTrans = trans[i];
        runningPoints -= thisTrans.Points;
        if( runningPoints < affordedRefund.Points ) break;
        refundTrans = thisTrans;
      }
      if( refundTrans != null )
      {
        var time = appManager.getTime(refundTrans.Timestamp);
        sortOrder = (new Date()).getTime() - time;
      }
    }

    sortOrder -= 1000; // reduce by a second so that it is above transaction history
    var cheapestRefund = refunds[0]
    if( points < cheapestRefund.Points) return [];

    var didSelect = function() {appActions.requestFeatureName("Refunds")};
    var iconName = featureData.data.icon.replace("fa-", "")
    return [{
      didSelect : didSelect,
      title : featureData.data.title,
      body1 : featureData.data.tip,
      icon : iconName,
      cardType : 0,
      sortOrder : sortOrder
    }];
  }
}

Refunds.dataDependencies = ["EligibleRefunds"];

module.exports = Refunds;



// WEBPACK FOOTER //
// ./src/Refunds.js